import { render, staticRenderFns } from "./ItemsBreakdown.vue?vue&type=template&id=5362c6dc&scoped=true&"
import script from "./ItemsBreakdown.vue?vue&type=script&lang=js&"
export * from "./ItemsBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./ItemsBreakdown.vue?vue&type=style&index=0&id=5362c6dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362c6dc",
  null
  
)

export default component.exports